import { render, staticRenderFns } from "./retrieve.vue?vue&type=template&id=2b01a1f1&scoped=true"
import script from "./retrieve.vue?vue&type=script&lang=js"
export * from "./retrieve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01a1f1",
  null
  
)

export default component.exports